define(["underscore", "model/properties"], function(_, PropertiesModel) {
  function BuiltinResultPropertiesEnrichmentHandlerFactoryV1(module360) {
    this.module360 = module360;
  }

  _.extend(BuiltinResultPropertiesEnrichmentHandlerFactoryV1.prototype, {
    _containsAction: function(actionsData, action) {
      return !!actionsData.find(function(actionData) {
        return actionData && actionData.value && actionData.value.action && actionData.value.action[action];
      });
    },

    _add360ActionToResultProperties: function(resultProperties) {
      const m360Model = this.module360.getMindbreeze360Model();
      if (!m360Model) {
        console.warn("360 action is not added to result properties, skipped.");
        return;
      }

      var itemClassConfig = m360Model.findItemClassConfigForResult(new PropertiesModel(resultProperties));
      if (!itemClassConfig) {
        return;
      }

      const actionsData = resultProperties && resultProperties.actions && resultProperties.actions.data;

      if (actionsData && !this._containsAction(actionsData, "show360")) {
        actionsData.push({
          html:
            '<a data-action-name="show360" data-event-mask="mouseover|click|keypress|mousedown" data-item-class-name="' +
            itemClassConfig.name +
            '">360°</a>',
          value: {
            action: {
              show360: {}
            }
          }
        });
      }
    },

    _getAllItemClassDefintionProperties: function() {
      var mindbreeze360Model = this.module360.getMindbreeze360Model();
      if (!mindbreeze360Model) {
        return;
      }

      var itemClassDefinitionPropNames = mindbreeze360Model.getAllItemClassDefinitionPropertyNames();
      var addProperty = function(result, propertyName) {
        result[propertyName] = { name: propertyName, formats: ["VALUE"] };
      };

      return _.reduce(
        itemClassDefinitionPropNames,
        function(result, item) {
          if (_.isArray(item)) {
            _.each(item, function(propertyName) {
              addProperty(result, propertyName);
            });
          } else {
            addProperty(result, item);
          }
          return result;
        },
        {}
      );
    },

    getResultPropertiesEnrichmentHandlerFactoryV1: function() {
      var that = this;
      var promiseResult = function(resultProperties, additionalAttributes) {
        return new Promise(function(resolve, reject) {
          try {
            that._add360ActionToResultProperties(resultProperties);
            resolve(resultProperties);
          } catch (error) {
            reject(error);
          }
        });
      };
      var handler = function() {
        return {
          end: function() {},
          start: function() {},
          result: promiseResult,
          transformRequestedProperties: function(result) {
            var props = (that._getAllItemClassDefintionProperties && that._getAllItemClassDefintionProperties()) || {};
            var neededPropNames = _.difference(
              _.keys(props),
              _.map(result, function(propDef) {
                return propDef.name;
              })
            );
            return (
              result &&
              result.concat(
                _.map(neededPropNames, function(propName) {
                  return props[propName];
                })
              )
            );
          }
        };
      };
      return {
        createHandler: handler
      };
    }
  });

  return BuiltinResultPropertiesEnrichmentHandlerFactoryV1;
});
